// extracted by mini-css-extract-plugin
export var brand = "_8s-9";
export var compact = "_8s-6";
export var extraSmall = "_8s-7";
export var icon = "_8s-0";
export var large = "_8s-4";
export var light = "_8s-1";
export var medium = "_8s-5";
export var outline = "_8s-b";
export var primaryDark = "_8s-a";
export var primaryLight = "_8s-8";
export var primaryModern = "_8s-c";
export var success = "_8s-2";
export var successSolid = "_8s-3";